
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import { useRouter } from "vue-router";
import { useAPIReturnParams } from "@/hooks/doc";
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  ref,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { deleteApiReturnParam } from "@/service/api";
import returnParamInfo from "../modules/returnParamInfo.vue";
import useCurrentInstance from "@/utils/useCurrentInstance";

export default defineComponent({
  components: {
    returnParamInfo,
  },
  setup() {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      activeType: "",
      formData: {},
      title: router.currentRoute.value.query.title,
      userId: computed(() => store.state.manageUser.userId),
      name: computed(() => store.state.manageUser.name),
    });
    const loading = ref(true);
    const visibleModal = ref(false);
    const apiReturnParams = computed(
      () => store.state.doc.apiDetail.apiReturnParams
    );
    const apiId = router.currentRoute.value.query.id;
    const { proxy } = useCurrentInstance();
    /**
     * 获取接口返回值
     */
    const getAPIReturnParams = async () => {
      loading.value = true;
      await useAPIReturnParams(store, apiId as any);
      loading.value = false;
    };
    //打开添加参数弹框
    function addReturnParam(row: any) {
      if (row == -1) {
        state.activeType = "添加返回值";
        state.formData = {};
        visibleModal.value = true;
      } else {
        state.activeType = "修改返回值";
        state.formData = row;
        visibleModal.value = true;
      }
    }
    //关闭弹窗
    function closeModal() {
      visibleModal.value = false;
    }
    //删除接口参数
    function batchDelete(id: string) {
      ElMessageBox.confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const params = {
            id: id,
            userId: state.userId,
            userRealname: state.name,
          };
          const result = await deleteApiReturnParam(params);
          if (result && parseInt(result.code) === 1) {
            ElMessage({ message: "删除成功", type: "success" });
            getAPIReturnParams();
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        })
        .catch(() => {});
    }
    function headerStyle() {
      const cellStyle =
        "background: #ffffff;color: #333333;font-weight:700;width: 100%; font-size: 12px";
      return cellStyle;
    }
    /**
     * 初始加载数据
     */
    onMounted(async () => {
      const currentPathArr = [
        {
          title: "API接口管理(新)",
          path: "",
          name: "",
        },
        {
          title: "接口列表(新)",
          path: proxy.$routerBase + "/interfaceList",
          name: "interfaceList",
          isLink: true,
        },
        {
          title: state.title + "——返回值管理",
          path: "",
          name: "",
        },
      ];
      proxy.changeCurrentPath(currentPathArr);
      await getAPIReturnParams();
    });
    return {
      ...toRefs(state),
      visibleModal,
      loading,
      apiReturnParams,
      apiId,
      addReturnParam,
      closeModal,
      batchDelete,
      getAPIReturnParams,
      headerStyle,
    };
  },
});
